import * as React from 'react';
import { IToaster, IToasterProps, Position, Toaster as BlueprintToaster } from '@blueprintjs/core';

import './styles.scss';
import { uniqueId } from 'lodash';

import Toast, { IToastProps } from '../Toast';

export interface ICustomToasterProps extends IToaster, IToasterProps {
    addToast: (toastProps: IToastProps) => void;
}

/**
 * Creartes a blueprint toaster host with predefined setup.
 */

export const Toaster: ICustomToasterProps = Object.assign(BlueprintToaster.create({
    position: Position.TOP,
    autoFocus: false,
}), {
    addToast: (toastProps: IToastProps) => {
        const toastKey = uniqueId();
        Toaster.show({
            message: (
                <Toast {...toastProps} toastKey={toastKey}/>
            ),
            timeout: toastProps.timeout ? toastProps.timeout : 3000,
        }, toastKey);
    },
});

export default Toaster;
